import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Magnetic from './Magnetic'
import { AnimatePresence, motion } from 'framer-motion';
import Nav from './Header/Nav'
import Button from './Header/Button';
import styles from './style.module.scss'
import logo from '../img/SteamLogo.png'

const menu = {
  open: {
      width: "480px",
      height: "650px",
      top: "-25px",
      right: "-25px",
      transition: { duration: 0.75, type: "tween", ease: [0.76, 0, 0.24, 1]}
  },
  closed: {
      width: "100px",
      height: "40px",
      top: "0px",
      right: "0px",
      transition: { duration: 0.75, delay: 0.35, type: "tween", ease: [0.76, 0, 0.24, 1]}
  }
}

const Navbar = () => {

  const [isActive, setIsActive] = useState(false);

  return (
      <div className='navbar'>
          <div className='nav-container'>
                <Magnetic>
                  <div className='logo'>
                    <img src={logo}/>
                      <Link to='/' className='link'>
                          <h3>STEAM</h3>
                          <div className='indicator'></div>
                      </Link>
                  </div>
                </Magnetic>

                <div className={styles.header}>
                  <motion.div 
                      className={styles.menu}
                      variants={menu}
                      animate={isActive ? "open" : "closed"}
                      initial="closed"
                  >
                      <AnimatePresence>
                          {isActive && <Nav />}
                      </AnimatePresence>
                  </motion.div>
                  <Button isActive={isActive} toggleMenu={() => {setIsActive(!isActive)}}/>
                </div>
          </div>
      </div>
  )
}

export default Navbar